
import { CustomApiResponse } from "utils/helper/ApiResponses";
import {  ProductPerformance, ReportQuery, UserSpendingPerformance } from "utils/types/reports.types";
import { BalanceSheet, CashFlowStatement, IncomeStatement } from "utils/types/Accounting.types";
import { ApiService } from "../apiservices";
import { apiSrcUrl } from "../ApiRoutes";

/**
 * Helper function to build a URL query string from a filter object.
 * It ignores undefined or null values.
 */
function buildQueryString(query: ReportQuery): string {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, String(value));
    }
  });
  return params.toString();
}

// --- BI Reports ---

export async function getTopSoldProducts(token: string, query: ReportQuery): Promise<ProductPerformance[]> {
  const queryString = buildQueryString(query);
  const response = await ApiService.get<CustomApiResponse<ProductPerformance[]>>(
    `${apiSrcUrl}/private/reports/top-products?${queryString}`,
    { Authorization: `Bearer ${token}` }
  );
  if (response.data.status === 'success' && response.data.data) return response.data.data;
  throw new Error(response.data.message);
}

export async function getTopSpendingUsers(token: string, query: ReportQuery): Promise<UserSpendingPerformance[]> {
  const queryString = buildQueryString(query);
  const response = await ApiService.get<CustomApiResponse<UserSpendingPerformance[]>>(
    `${apiSrcUrl}/private/reports/top-spending-users?${queryString}`,
    { Authorization: `Bearer ${token}` }
  );
  if (response.data.status === 'success' && response.data.data) return response.data.data;
  throw new Error(response.data.message);
}

// --- Financial Statement Reports ---

export async function getIncomeStatement(token: string, query: ReportQuery): Promise<IncomeStatement> {
  const queryString = buildQueryString(query);
  const response = await ApiService.get<CustomApiResponse<IncomeStatement>>(
    `${apiSrcUrl}/private/reports/income-statement?${queryString}`,
    { Authorization: `Bearer ${token}` }
  );
  if (response.data.status === 'success' && response.data.data) return response.data.data;
  throw new Error(response.data.message);
}

export async function getBalanceSheet(token: string, query: ReportQuery): Promise<BalanceSheet> {
  const queryString = buildQueryString(query);
  const response = await ApiService.get<CustomApiResponse<BalanceSheet>>(
    `${apiSrcUrl}/private/reports/balance-sheet?${queryString}`,
    { Authorization: `Bearer ${token}` }
  );
  if (response.data.status === 'success' && response.data.data) return response.data.data;
  throw new Error(response.data.message);
}

export async function getCashFlowStatement(token: string, query: ReportQuery): Promise<CashFlowStatement> {
  const queryString = buildQueryString(query);
  const response = await ApiService.get<CustomApiResponse<CashFlowStatement>>(
    `${apiSrcUrl}/private/reports/cash-flow?${queryString}`,
    { Authorization: `Bearer ${token}` }
  );
  if (response.data.status === 'success' && response.data.data) return response.data.data;
  throw new Error(response.data.message);
}